<template>
    <form class="vrm-form" @submit.prevent="submit">
        <fieldset class="vrm-form__fieldset">
            <slot />
        </fieldset>
    </form>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class VrmForm extends Vue {
    submit() {
        if (this.validate()) {
            this.$emit('submit');
        }
    }

    validate() {
        this.hasErrors = false;
        this.validateChild(this);
        return !this.hasErrors;
    }

    hasErrors = false;

    validateChild(component) {
        if ('vrmValidate' in component) {
            const valid = component.vrmValidate();
            if (!valid) {
                this.hasErrors = true;
            }
        } else {
            component.$children.forEach(child => this.validateChild(child));
        }
    }
}
</script>
